import { BuyerAuthMutation } from '@gql/BuyerAuthMutation'
import type { HookResult } from '@nuxt/schema'
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export function useAuthFull() {
  const { $localeSync, callHook, $apollo } = useNuxtApp()
  const { update, prom } = updateUserDoc()

  async function useAuthReset(logs: string) {
    update({ loading: true, isAuth: false })
    try {
      const promise = helpers
        .sleep(10)
        .then(() => {
          if (import.meta.dev) console.log('[lang][i18n useAuthReset]', logs)
          return $apollo.post.resetStore()
        })
        .catch((err): void => console.error('[useAuthReset:err]', err))
      prom.value = { promise }
      await promise
      await helpers.sleep(10)
      await callHook('app:reset')
      await $localeSync('from:useAuthReset')
    } catch (err) {
      console.error('[useAuthReset]', err)
    }
  }
  return { useAuthReset }
}

export async function useBuyerAuthUpdate(input: gen.InputBuyerAuth) {
  const { useAuthReset } = useAuthFull()
  const res = await useGqlMutate<gen.BuyerAuthMutation, gen.BuyerAuthMutationVariables>(BuyerAuthMutation, { clientId: 'post', vars: { input } })
  if (res?.data?.buyerAuth?.authChanged) await useAuthReset('useBuyerAuthUpdate authChanged is true')
  return res
}

declare module '#app' {
  interface RuntimeNuxtHooks {
    'app:reset'(): HookResult
  }
}
